import c_11 from "../../assets/audio-screen/unit11/c_11.mp3"
import c_11_1 from "../../assets/audio-screen/unit11/c_11_1.mp3"


export const audio11 = [
   {
    'text':'Garry: Xin chào Le, Hôm nay cậu có khỏe không?\nLe: Tớ khoẻ cảm ơn, thế còn cậu?\nGarry: Tớ khỏe, tớ sẽ đến Việt Nam vào tháng tới. Thời tiết ở Việt Nam như thế nào?\nLe: Bây giờ là mùa Đông ở miền bắc và miền tây Việt Nam. Nhưng có sự khác biệt của từng vùng. Mùa Đông ở Đà lạt lạnh hơn ở Hà Nội.\nGarry: Thế tớ nên mang nhiều quần áo ấm, có phải không?\nLe: Đúng rồi, cậu nên mang đủ quần áo ấm hơn nhé!\nGarry: Cảm ơn cậu, thế còn thời tiết ở Sài Gòn vào thời điểm này thế nào?\nLe: Sài Gòn hầu như nhiệt độ cao hơn và nóng hơn Hà Nội bởi vì Sài Gòn là miền Nam còn Hà Nội là miền Bắc của Việt Nam.\nGarry: Tớ hiểu rồi, cảm ơn cậu nhé. Khi đến Việt Nam tớ sẽ đi thăm câu. Cậu có thời gian đi du lịch cũng to không?\nLe: Tớ sẽ thu xếp thời gian và thông báo lại cho cậu sớm nhé.\nGarry: Tớ hiểu rồi!\n',
    'audio': c_11,
  },

];

export const audio11_1 = [
    {
      'text':'Hà: Chào chị, chị muốn mua gì ạ?\nLee Sang He: Chào em, chị muốn mua cam và táo.\nHà: Đã chỉ, ở đây chỉ bán cam và xoài thôi ạ.\nLee Sang He: Cửa hàng mình loại xoài nào rẻ nhất và loại nào đắt nhất em? Chất lượng như thế nào?\nHà: Của hàng em có loại xoài của Mỹ là đắt nhất chị ạ, còn xoài Thái cũng đắt nhưng rẻ hơn xoài Mỹ một chút.\nLee Sang He: Thế thì em bán cho chị 5 kilogram nhé.\nHà: Dạ của chị đấy ạ.\n',
      'audio': c_11_1,
   },
 
 ];